import React, { Component } from 'react'

import {LogintroubleForm} from './LogintroubleForm'

export default class Logintrouble extends Component {
    renderForm() {
        return(
            <LogintroubleForm/>
        )
    }
    render() {
        return(
            <div>
                {this.renderForm()}
            </div>
        )
    }
}